import type { ReactNode } from 'react';
import { memo } from 'react';
import { createPortal } from 'react-dom';

const ReactPortal = ({ children }: { children: ReactNode }) => createPortal(children, document.body);

export default memo(ReactPortal);
